import { render, staticRenderFns } from "./index.vue?vue&type=template&id=4acf8f6b"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/pre环境/快递系统/快递前端/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4acf8f6b')) {
      api.createRecord('4acf8f6b', component.options)
    } else {
      api.reload('4acf8f6b', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=4acf8f6b", function () {
      api.rerender('4acf8f6b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/transport/driver/index.vue"
export default component.exports